import {
  changeFieldValue,
  getCarData,
  getFormValue,
  getUserData,
  setQuestionVisibility,
} from 'app/services/businessFunctionHelpers';
import {
  FieldsEnum,
  FormsEnum,
  MainOwnerSelectionEnum,
} from 'app/shared/enums';
import { setMainOwnerSelectionDictionary } from 'app/shared/helpers/setMainOwnerSelectionDictionary';

export const setMainOwnerSelectionQuestionVisibility = () => {
  const isOperator = getUserData().user?.operator;
  const coownersCount = getCarData().coownersCount;
  const showMorePersonalData = getFormValue(FieldsEnum.PersonalDataPath);
  const currentMainOwnerSelection = getFormValue(FieldsEnum.MainOwnerSelection);

  if (!isOperator) return;

  const visible =
    showMorePersonalData && Number(coownersCount?.replace('_', '')) === 1;

  setQuestionVisibility({
    key: FieldsEnum.MainOwnerSelection,
    visible,
    formName: FormsEnum.CalculationForm,
  });

  if (visible) {
    setMainOwnerSelectionDictionary();
    if (!currentMainOwnerSelection)
      changeFieldValue(
        FieldsEnum.MainOwnerSelection,
        MainOwnerSelectionEnum.MainOwner,
        FormsEnum.CalculationForm
      );
  }
};
